import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "orchestrator.bookingForm.title",
    defaultMessage: "Booking form",
  },
  checkIn: {
    id: "orchestrator.bookingForm.checkIn",
    defaultMessage: "Check-in",
  },
  checkOut: {
    id: "orchestrator.bookingForm.checkOut",
    defaultMessage: "Check-out",
  },
  occupancy: {
    id: "orchestrator.bookingForm.occupancy",
    defaultMessage: "Occupancy",
  },
  adults: {
    id: "orchestrator.bookingForm.adults",
    defaultMessage: "Adults",
  },
  juniors: {
    id: "orchestrator.bookingForm.juniors",
    defaultMessage: "Teenagers",
  },
  children: {
    id: "orchestrator.bookingForm.children",
    defaultMessage: "Children",
  },
  babies: {
    id: "orchestrator.bookingForm.babies",
    defaultMessage: "Babies",
  },
  childrenCount: {
    id: "orchestrator.bookingForm.childrenCount",
    defaultMessage: "Children",
  },
  childAge: {
    id: "orchestrator.bookingForm.childAge",
    defaultMessage: "Age of child {index}",
  },
  submit: {
    id: "orchestrator.bookingForm.submit",
    defaultMessage: "Go to booking engine",
  },
});
